import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import { paramsToQueryIdentifier } from '../../../util/query';
import { modelOf } from '../../../prop-types';
import ContentForState from '../../loader/ContentForState';
import RequestState from '../../../types/RequestState';
import CustomerUserStore from '../../../store/CustomerUserStore';
import globalTranslations from '../../../i18n/globalTranslations';
import PurchaseProductItem from '../PurchaseProductItem';
import UIStore from '../../../store/UIStore';

@observer
export class PurchaseProductList extends Component {
  componentDidMount() {
    this.loadPurchaseProducts();
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(prevProps.userId, this.props.userId) ||
      !isEqual(prevProps.currency, this.props.currency) ||
      !isEqual(prevProps.searchParams, this.getQueryParameters())
    ) {
      this.loadPurchaseProducts();
    }
  }

  loadPurchaseProducts = () => {
    const { customerUserStore, userId } = this.props;

    if (
      userId !== undefined &&
      !this.getCurrentResult() &&
      customerUserStore.productQueryStates.get(this.getQueryIdentifier()) !==
        RequestState.LOADING
    ) {
      customerUserStore.loadPurchaseProducts(this.getQueryParameters());
    }
  };

  getQueryParameters = () => {
    const { userId, searchParams, currency } = this.props;
    return {
      userId: userId,
      startDate: searchParams.startDate,
      endDate: searchParams.endDate,
      currency: currency,
    };
  };

  getQueryIdentifier = () => {
    return paramsToQueryIdentifier(this.getQueryParameters());
  };

  getCurrentResult = () => {
    return this.props.customerUserStore.productQueryResults.get(
      this.getQueryIdentifier()
    );
  };

  renderHeaders = () => {
    const { isMobile } = this.props.uiStore;

    if (isMobile) {
      return null;
    }

    return (
      <div className="PurchaseProductList__headers">
        <Row>
          <Col md="6">
            <FormattedMessage {...globalTranslations.productTitle} />
          </Col>
          <Col md="2">
            <FormattedMessage {...globalTranslations.quantityTitle} />
          </Col>
          <Col md="2">
            <FormattedMessage {...globalTranslations.sumWithVat} />
          </Col>
          <Col md="2">
            <FormattedMessage {...globalTranslations.sumWithoutVat} />
          </Col>
        </Row>
      </div>
    );
  };

  renderProducts = () => {
    const products = this.getCurrentResult();

    return products.map((product) => {
      return <PurchaseProductItem key={product.id} purchaseProduct={product} />;
    });
  };

  render() {
    const { customerUserStore } = this.props;
    const state = customerUserStore.productQueryStates.get(
      this.getQueryIdentifier()
    );
    return (
      <div className="PurchaseProductList">
        <ContentForState
          state={state}
          forLoaded={() => (
            <>
              {this.renderHeaders()}
              {this.renderProducts()}
            </>
          )}
        />
      </div>
    );
  }
}

PurchaseProductList.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  currency: PropTypes.string.isRequired,
  searchParams: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
};

export default withRouter(
  inject('customerUserStore', 'uiStore')(PurchaseProductList)
);
